/* jshint asi:true */

'use strict'

/**
 * Expose `utils` modules
 */

module.exports = {
  regex: require('es6-template-regex'),
  extendShallow: require('extend-shallow'),
  getValue: require('get-value'),
  sliced: require('sliced')
}
